import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function PurchaseStock() {
  const [products, setProducts] = useState([]);
  const [entries, setEntries] = useState([]);

  // ✅ Added state for Unit Cost (₹)
  const [unitCost, setUnitCost] = useState("");
  const [expiryDate, setExpiryDate] = useState("");


  const [form, setForm] = useState({
    product_id: "",
    qty: "",
    supplier: "",
    invoice_no: "",
    batch_no: "",
    remarks: "",
  });

  const loadProducts = async () => {
    const res = await fetch(`${API_BASE}/products/list`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setProducts(Array.isArray(data) ? data : []);
  };

  const loadEntries = async () => {
    const res = await fetch(`${API_BASE}/inventory/in/list`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    if (data.success) setEntries(data.data);
  };

  useEffect(() => {
    loadProducts();
    loadEntries();
  }, []);

  const saveStockIn = async () => {
    if (!form.product_id || !form.qty) {
      alert("Product and quantity are required");
      return;
    }

    const res = await fetch(`${API_BASE}/inventory/in`, {
      method: "POST",
      headers: authHeaders({
          "Content-Type": "application/json",
        }),
      // ✅ Submit payload with unit_cost
      body: JSON.stringify({
  product_id: form.product_id,
  qty: form.qty,
  unit_cost: Number(unitCost),
  expiry_date: expiryDate || null,
  supplier: form.supplier,
  invoice_no: form.invoice_no,
  batch_no: form.batch_no,
  remarks: form.remarks,
}),
 });


    const data = await res.json();

    if (data.success) {
      alert("Stock-In saved!");
      setForm({
        product_id: "",
        qty: "",
        supplier: "",
        invoice_no: "",
        batch_no: "",
        remarks: "",
      });
      // ✅ Reset unitCost after save
      setUnitCost("");
      setExpiryDate("");

      loadEntries();
    } else {
      alert(data.message);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Purchase / Stock-In</h2>

      <div
        style={{
          width: "500px",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "30px",
          boxShadow: "0 0 10px rgba(0,0,0,0.15)",
        }}
      >
        <h3>Add Stock-In Entry</h3>

        <select
          value={form.product_id}
          onChange={(e) =>
            setForm({ ...form, product_id: e.target.value })
          }
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          <option value="">Select Product</option>
          {products.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>

        <input
          type="number"
          placeholder="Quantity"
          value={form.qty}
          onChange={(e) => setForm({ ...form, qty: e.target.value })}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        {/* ✅ Added Unit Cost input field */}
        <input
          type="number"
          step="0.01"
          placeholder="Unit Cost (₹)"
          value={unitCost}
          onChange={(e) => setUnitCost(e.target.value)}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <input
          placeholder="Supplier"
          value={form.supplier}
          onChange={(e) => setForm({ ...form, supplier: e.target.value })}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <input
          placeholder="Invoice No"
          value={form.invoice_no}
          onChange={(e) => setForm({ ...form, invoice_no: e.target.value })}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <input
          placeholder="Batch No"
          value={form.batch_no}
          onChange={(e) => setForm({ ...form, batch_no: e.target.value })}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />
<div style={{ fontSize: 12, color: "#555", marginBottom: 4 }}>
  Expiry Date (optional)
</div>
<input
  type="date"
  value={expiryDate}
  onChange={(e) => setExpiryDate(e.target.value)}
  style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
/>



        <textarea
          placeholder="Remarks"
          value={form.remarks}
          onChange={(e) => setForm({ ...form, remarks: e.target.value })}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <button
          onClick={saveStockIn}
          style={{
            width: "100%",
            padding: "10px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
          }}
        >
          Save Stock-In
        </button>
      </div>

      <h3>Stock-In Entries</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
  <tr style={{ background: "#eee" }}>
    <th style={{ padding: "10px" }}>Product</th>
    <th style={{ padding: "10px" }}>Qty</th>
    <th style={{ padding: "10px" }}>Expiry Date</th>
    <th style={{ padding: "10px" }}>Supplier</th>
    <th style={{ padding: "10px" }}>Invoice</th>
    <th style={{ padding: "10px" }}>Batch</th>
    <th style={{ padding: "10px" }}>Date</th>
  </tr>
</thead>

        <tbody>
          {entries.length === 0 ? (
            <tr><td colSpan="7" style={{ padding: "10px" }}>No entries found</td></tr>
          ) : (
            entries.map((e, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
  <td style={{ padding: "10px" }}>{e.product_name}</td>
  <td style={{ padding: "10px" }}>{e.qty}</td>
  <td style={{ padding: "10px" }}>
    {e.expiry_date ? new Date(e.expiry_date).toLocaleDateString() : "-"}
  </td>
  <td style={{ padding: "10px" }}>{e.supplier}</td>
  <td style={{ padding: "10px" }}>{e.invoice_no}</td>
  <td style={{ padding: "10px" }}>{e.batch_no}</td>
  <td style={{ padding: "10px" }}>
    {new Date(e.date).toLocaleString()}
  </td>
</tr>

            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
